module.exports = __webpack_public_path__ + "img/zoo.8a75e76c.png";